import  { useContext, useMemo } from 'react'
import { UserDetailsContext } from '../context/userDetails'
import { getSessionStorage, getShopType } from '../utils/util';
import { SESSION_STORAGE_KEY } from '../vars';

function useShopType () {
    const {shopDomain} = useContext(UserDetailsContext);
    const domain = shopDomain || getSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN);
    const shopType = useMemo(() => getShopType(domain), [domain]);

  return { ...shopType };
}

export default useShopType